import React from 'react';
import { Box, Stack } from '@mui/material';
import styles from './ListItem.styles';
import IconMi from 'components/common/icon/IconMi';
import ListItem from './ListItem';
import { FormControlPageVariablesProps, ListItemConfig, ListItemValue, TagSource, VariableData } from './index';
import { FormComponentValue } from 'components/common/form/layout/control';
import { SortableHandle } from 'react-sortable-hoc';
import { TListType } from '../index';
import { YNValues } from 'tools/types';

function ListTypeWrapper({
    uid,
    index,
    item,
    listConfig,
    controlProps,
    updateListItemValue,
    setShowLoader,
    deleteListItem,
    loadOptions,
    tag,
}: {
    uid: string;
    index: number;
    item: ListItemValue;
    listConfig: Array<ListItemConfig> | string;
    controlProps: FormControlPageVariablesProps;
    updateListItemValue: (itemIndex: number, valueName: string, value: string) => void;
    setShowLoader: (value: boolean) => void;
    deleteListItem: (index: number) => void;
    loadOptions: (
        inputValue: string,
        options: string,
        source: TagSource,
        key: string,
        multiple: YNValues,
        init?: boolean,
        index?: number,
    ) => Promise<FormComponentValue[]>;
    tag: VariableData;
}) {
    const DragHandle = SortableHandle(() => <IconMi icon="drag-and-drop-grid" sx={styles.dragAndDropIcon} />);

    return (
        <Box sx={{ pt: 1 }} className={'list-item-holder'} key={'list-item-wrapper-' + item.list_item_uid}>
            <Stack direction={'row'} className={'list-item-wrapper'} sx={styles.listItemsBlock}>
                <Box sx={styles.dragAndDropWrapper}>
                    <DragHandle />
                </Box>
                <ListItem
                    itemIndex={index}
                    itemValue={item}
                    listConfig={listConfig}
                    tagUID={uid}
                    controlProps={controlProps}
                    updateListItemValue={(valueName: string, value: string) => {
                        updateListItemValue(index, valueName, value);
                    }}
                    setShowLoader={setShowLoader}
                    loadOptions={loadOptions}
                    tag={tag}
                />
                <Box sx={styles.deleteItemWrapper}>
                    <Box onClick={() => deleteListItem(index)} sx={styles.deleteButton}>
                        <IconMi icon={'trash'} fontSize={'16'} />
                    </Box>
                </Box>
            </Stack>
        </Box>
    );
}

export default ListTypeWrapper;
